import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'
import styles from '../styles'

const ChatMainView = ({ classes, children, title }) => {
  return (
    <section className={classes.wrapper}>
      <header className={classes.header}>
        <h5 className={classes.title}>{title}</h5>
      </header>
      {children}
    </section>
  )
}

ChatMainView.propTypes = {
  classes: PropTypes.object,
}

export default injectStyles(styles)(ChatMainView)
